import React from 'react'

class Item extends React.Component {

  onClick = () => {
    let {
      completed,
      onClick,
      state,
    } = this.props;

    if (completed) {
      onClick(state)
    }
  }

  activeClass() {
    return this.props.active ? 'active' : ''
  }

  completedClass() {
    return this.props.completed ? 'completed' : ''
  }

  render() {
    let { state } = this.props

    return(
      <li
        key={state}
        className={ `${this.activeClass()} ${this.completedClass()}` }
        onClick={ this.onClick }
      >
        { I18n.t(`loan_application_user.flow_state.${this.props.state}`) }
      </li>
    )
  }
}

export default Item;
